import React from "react";
import styles from "./Footer.module.css";
import logo from "../assets/linked.png";
const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerBottom}>
        <div className={styles.socialIcons}>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={logo}
              alt="logo"
              style={{ width: "80px", height: "30px" }}
            />
          </a>
        </div>
        <span className={styles.copyright}>
          © {new Date().getFullYear()} KASIBHATLAWS &mdash; All rights reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
